/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../../$$_gendir/node_modules/angular2-spinner/dist/angular2-spinner.ngfactory';
import * as import2 from 'angular2-spinner/dist/angular2-spinner';
import * as import3 from '@angular/router';
import * as import4 from '@angular/common';
import * as import5 from '../../../app/pipes/array.pipe';
import * as import6 from '../../../app/server/server-dashboard-info.component';
import * as import7 from '../../../app/services/api.service';
import * as import8 from '../../../app/services/ipmi.service';
import * as import9 from '../../../app/services/local-storage.service';
import * as import10 from '../../../app/services/response.service';
import * as import11 from 'angular2-notifications/src/notifications.service';
const styles_ServerDashboardInfoComponent:any[] = ([] as any[]);
export const RenderType_ServerDashboardInfoComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_ServerDashboardInfoComponent,
  data: {}
}
);
function View_ServerDashboardInfoComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'spinner center-v-h'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'p',[[
        'class',
        'spinner-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Wczytywanie danych serwera'])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'spinner',([] as any[]),[
      [
        4,
        'width',
        'px'
      ]
      ,
      [
        4,
        'height',
        'px'
      ]
      ,
      [
        4,
        'borderWidth',
        'px'
      ]
      ,
      [
        4,
        'borderTopColor',
        (null as any)
      ]
      ,
      [
        4,
        'borderBottomColor',
        (null as any)
      ]
      ,
      [
        4,
        'borderLeftColor',
        (null as any)
      ]
      ,
      [
        4,
        'borderRightColor',
        (null as any)
      ]

    ]
    ,(null as any),(null as any),import1.View_SpinnerComponent_0,import1.RenderType_SpinnerComponent)),
    import0.ɵdid(114688,(null as any),0,import2.SpinnerComponent,([] as any[]),{
      size: [
        0,
        'size'
      ]
      ,
      tickness: [
        1,
        'tickness'
      ]

    }
    ,(null as any)),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    const currVal_7:any = 35;
    const currVal_8:any = 3;
    ck(v,6,0,currVal_7,currVal_8);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,6).size;
    const currVal_1:any = import0.ɵnov(v,6).size;
    const currVal_2:any = import0.ɵnov(v,6).tickness;
    const currVal_3:any = import0.ɵnov(v,6).color;
    const currVal_4:any = import0.ɵnov(v,6).secondColor;
    const currVal_5:any = import0.ɵnov(v,6).secondColor;
    const currVal_6:any = import0.ɵnov(v,6).secondColor;
    ck(v,5,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
  });
}
function View_ServerDashboardInfoComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),5,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'a',[
      [
        'class',
        'btn btn-medium'
      ]
      ,
      [
        'routerLink',
        '/messages/new'
      ]

    ]
    ,[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,3).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(671744,(null as any),0,import3.RouterLinkWithHref,[
      import3.Router,
      import3.ActivatedRoute,
      import4.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['Zgłoś awarię'])),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    const currVal_2:any = '/messages/new';
    ck(v,3,0,currVal_2);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,3).target;
    const currVal_1:any = import0.ɵnov(v,3).href;
    ck(v,2,0,currVal_0,currVal_1);
  });
}
function View_ServerDashboardInfoComponent_5(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'li',[[
        'class',
        'row-medium'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ':'
    ]
    )),
    (l()(),import0.ɵted((null as any),[
      ' ',
      '\n                '
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = v.context.$implicit.name;
    ck(v,3,0,currVal_0);
    const currVal_1:any = v.context.$implicit.properties.name;
    ck(v,4,0,currVal_1);
  });
}
function View_ServerDashboardInfoComponent_4(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),5,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),2,(null as any),View_ServerDashboardInfoComponent_5)),
    import0.ɵdid(802816,(null as any),0,import4.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    import0.ɵppd(1),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,3,0,ck(v,4,0,import0.ɵnov((<any>(<any>v.parent).parent),0),v.context.$implicit.types));
    ck(v,3,0,currVal_0);
  },(null as any));
}
function View_ServerDashboardInfoComponent_6(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'li',[[
        'class',
        'row-medium'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['System operacyjny:'])),
    (l()(),import0.ɵted((null as any),[
      ' ',
      '\n                '
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = (co.serverOS? co.serverOS.name: 'Nie zainstalowano');
    ck(v,4,0,currVal_0);
  });
}
function View_ServerDashboardInfoComponent_8(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Login:']))
  ]
  ,(null as any),(null as any));
}
function View_ServerDashboardInfoComponent_7(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'li',[[
        'class',
        'row-medium'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDashboardInfoComponent_8)),
    import0.ɵdid(16384,(null as any),0,import4.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),[
      ' ',
      '\n                '
    ]
    ))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = (co.serverOS.name != 'BRAK');
    ck(v,3,0,currVal_0);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_1:any = co.serverOS.login;
    ck(v,4,0,currVal_1);
  });
}
function View_ServerDashboardInfoComponent_10(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Hasło: ']))
  ]
  ,(null as any),(null as any));
}
function View_ServerDashboardInfoComponent_9(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),6,'li',[[
        'class',
        'row-medium'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDashboardInfoComponent_10)),
    import0.ɵdid(16384,(null as any),0,import4.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'button',[
      [
        'class',
        'btn btn-small'
      ]
      ,
      [
        'style',
        'margin-left: 15px;'
      ]

    ]
      ,(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.getOSPassword(co.passwordModal)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Pobierz hasło'])),
    (l()(),import0.ɵted((null as any),['\n                ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = (co.serverOS.name != 'BRAK');
    ck(v,3,0,currVal_0);
  },(null as any));
}
function View_ServerDashboardInfoComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),61,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n  '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),33,'div',[[
        'class',
        'blocks header'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h2',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      'Serwer: ',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'blocks'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'a',[[
        'class',
        ' heading-h3'
      ]
    ],[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,14).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(671744,(null as any),0,import3.RouterLinkWithHref,[
      import3.Router,
      import3.ActivatedRoute,
      import4.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['Sterowanie oraz adresacja IP'])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[[
        'class',
        'inactive heading-h3'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Informacje o serwerze'])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),12,'div',[[
        'class',
        'options blocks'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'span',[[
        'class',
        'status-indicator'
      ]
      ],[[
        2,
        'active',
        (null as any)
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Stan: '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'strong',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDashboardInfoComponent_3)),
    import0.ɵdid(16384,(null as any),0,import4.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),23,'div',[[
        'class',
        'blocks'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),5,'ul',[
      [
        'class',
        'no-bullet'
      ]
      ,
      [
        'style',
        'margin-right: 150px'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),2,(null as any),View_ServerDashboardInfoComponent_4)),
    import0.ɵdid(802816,(null as any),0,import4.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    import0.ɵppd(1),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),13,'ul',[[
        'class',
        'no-bullet'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDashboardInfoComponent_6)),
    import0.ɵdid(16384,(null as any),0,import4.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDashboardInfoComponent_7)),
    import0.ɵdid(16384,(null as any),0,import4.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDashboardInfoComponent_9)),
    import0.ɵdid(16384,(null as any),0,import4.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_3:any = import0.ɵinlineInterpolate(2,'/server/dashboard/',co.contractID,'/',co.serverID,'');
    ck(v,14,0,currVal_3);
    const currVal_6:any = co.serverIsReady;
    ck(v,33,0,currVal_6);
    const currVal_7:any = import0.ɵunv(v,42,0,ck(v,43,0,import0.ɵnov((<any>v.parent),0),co.serverParameters));
    ck(v,42,0,currVal_7);
    const currVal_8:any = co.serverOS;
    ck(v,51,0,currVal_8);
    const currVal_9:any = co.serverOS;
    ck(v,54,0,currVal_9);
    const currVal_10:any = co.serverOS;
    ck(v,57,0,currVal_10);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.server.name;
    ck(v,7,0,currVal_0);
    const currVal_1:any = import0.ɵnov(v,14).target;
    const currVal_2:any = import0.ɵnov(v,14).href;
    ck(v,13,0,currVal_1,currVal_2);
    const currVal_4:any = co.serverStatus;
    ck(v,26,0,currVal_4);
    const currVal_5:any = (co.serverIsReady? (co.serverStatus? 'WŁĄCZONY': 'WYŁĄCZONY'): 'W PRZYGOTOWYWANIU');
    ck(v,29,0,currVal_5);
  });
}
export function View_ServerDashboardInfoComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵpid(0,import5.ArrayPipe,([] as any[])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDashboardInfoComponent_1)),
    import0.ɵdid(16384,(null as any),0,import4.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n\n'])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDashboardInfoComponent_2)),
    import0.ɵdid(16384,(null as any),0,import4.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import6.ServerDashboardInfoComponent = v.component;
    const currVal_0:any = co.loadingServerData;
    ck(v,2,0,currVal_0);
    const currVal_1:boolean = !co.loadingServerData;
    ck(v,5,0,currVal_1);
  },(null as any));
}
function View_ServerDashboardInfoComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'app-server-dashboard-info',([] as any[]),(null as any),(null as any),(null as any),View_ServerDashboardInfoComponent_0,RenderType_ServerDashboardInfoComponent)),
    import0.ɵdid(114688,(null as any),0,import6.ServerDashboardInfoComponent,[
      import3.ActivatedRoute,
      import7.ApiService,
      import8.IpmiService,
      import9.LocalStorageService,
      import10.ResponseService,
      import11.NotificationsService
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const ServerDashboardInfoComponentNgFactory:import0.ComponentFactory<import6.ServerDashboardInfoComponent> = import0.ɵccf('app-server-dashboard-info',import6.ServerDashboardInfoComponent,View_ServerDashboardInfoComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/$$_gendir/app/server/server-dashboard-info.component.ngfactory.ts